import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Flex,
  Box,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  IconButton,
  useToast
} from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

import Logo from "@/assets/images/logo_grey.png";
import Logo2 from "@/assets/images/logo_blue.png";

import "./header.css";

import PersonalMenu from "./personalmenu";
import Login from "@/components/login";
import { useLazyWxtokenQuery } from "@/services/api/endpoints/wxlogin";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { login } from "@/services/api/thunks/users";
import { LoginForm, UserProfile } from "@/types/user";
import { useSelector } from "react-redux";
import { selectUnReadMsSystemNum, selectUser, updateUnReadMsSystemNum } from "@/reducer/userslice";
import loginbg from "@/assets/loginbg.png";
import MessageMenu from "./messagemenu";
import { RiNotification4Fill } from "@remixicon/react";
import {v4 as uuidv4} from 'uuid';
import { useLazyGetMsCountQuery } from "@/services/api/endpoints/mssystem";
const Header = () => {
  const user = useSelector(selectUser);
  const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loginDisclosure = useDisclosure();
  const [isSticky, setIsSticky] = useState(false);
  const [binding, setBinding] = useState(true);
  const [loginBy, setLoginBy] = useState(0);
  const [wxuser, setWxUser] = useState<UserProfile>();
  const location = useLocation();
  const [wxtoken] = useLazyWxtokenQuery();
  const currentUrl = location.pathname;
  const params = new URLSearchParams(window.location.search);
  const [menuOpen, setMenuOpen] = useState(false);
  const messageControl = useDisclosure();

  // 未读系统消息数
  const unReadMsSystemNumn = useAppSelector(selectUnReadMsSystemNum);
  const [getMsCount] =  useLazyGetMsCountQuery();
  const openMenu = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);
  //dispatch(updateUnReadMsSystemNum(data!))
  useEffect(() => {
   
    (async () => {
      const result = await getMsCount({})
      dispatch(updateUnReadMsSystemNum(result.data!))
    })();
    // 创建 WebSocket 连接
    const hostname = window.location.hostname=="localhost"?"192.168.1.6:8065":window.location.hostname;
    const connect_id= uuidv4();
    const webSocket = new WebSocket(`//${hostname}/api/v4/mssystem/ws?connect_id${connect_id}`);

    webSocket.onopen = () => {
      console.log('WebSocket连接已建立');
      webSocket.send(JSON.stringify("mssystem"));
    };

    webSocket.onmessage = (event) => {
      console.log(event.data)
      dispatch(updateUnReadMsSystemNum(event.data))
      // setMessages(event.data);
    };

    webSocket.onerror = (error) => {
      console.error('WebSocket错误:', error);
    };

    webSocket.onclose = () => {
      console.log('WebSocket连接已关闭');
    };
    // 清理函数，组件卸载时关闭 WebSocket 连接
    return () => {
      webSocket.close();
    };
  }, []);
  useEffect(() => {
    // 路由变化时关闭Menu
    closeMenu();
    messageControl.onClose();
  }, [location]);

  const goHome = () => {
    navigate("/"); // 切换到首页
  };

  const handLoginOrSignUp = async () => {
    setLoginBy(0);
    loginDisclosure.onOpen();
  };

  useEffect(() => {
    const handleWxLogin = async () => {
      if (params.get("code")) {
        const result = await wxtoken({ code: params.get("code")! }).unwrap();
        if (result.phone) {
          const form = { union_id: result.unionid } as LoginForm;
          const loginResult = await dispatch(login(form));
          if (loginResult.type == "users/login/fulfilled") {
            loginDisclosure.onClose();
          }
        } else {
          setWxUser(result);
          setBinding(false);
          setLoginBy(2);
          loginDisclosure.onOpen();
        }
      }
    };
    handleWxLogin();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const threshold = 0; // 设置在距离顶部0px时开始固定
      setIsSticky(window.scrollY > threshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const MemuItems = [
    { name: "发现", link: "/square" },
    { name: "AI生图", link: "/ai/design" },
    // { name: "AI扩图", link: "/ai/design" },
    { name: "AI生文", link: "/ai/writing" },
    { name: "AI实验室", link: "/ai/laboratory" },
    { name: "关于我们", link: "/about" },
    { name: "企业/学校", link: "/company" },
  ];

  const handleOpenMessage = () => {
    if (user && user.id) {
      messageControl.onOpen();
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  }

  return (
    <Box
      w="100%"
      sx={{
        position:
          // isSticky
          //   ? "fixed"
          //   :
          currentUrl === "/" ? "fixed" : "relative",
        top: 0,
        left: 0,
        zIndex: 999,
      }}
    >
      {/* 隐藏头 */}
      <Box w="100%" borderColor="blue" borderTopWidth={1}></Box>
      <div
        className={`header ${isSticky ? "sticky" : ""}
          ${currentUrl === "/" ? "header-home" : "header-normal"}`}
      >
        <Flex
          sx={{
            width: "100%",
            height: "100%",
            alignItems: "center",
          }}
        >
          <Box
            hideBelow="md"
            h="38px"
            w="122px"
            cursor="pointer"
            onClick={goHome}
          >
            <img className="leftlogo1" src={Logo} />
            <img className="leftlogo2" src={Logo2} />
          </Box>

          <Box flex={1}>
            <Flex
              hideBelow="md"
              maxW="80%"
              margin="0 auto"
              justifyContent={"space-around"}
              // justifyContent="center"
              // gap="120px"
            >
              {MemuItems.map((item, index) => (
                <NavLink
                  key={item.name}
                  to={item.link}
                  className={({ isActive }) =>
                    isActive ? "navbar-item navbar-item-active" : "navbar-item"
                  }
                >
                  {item.name}
                </NavLink>
              ))}
            </Flex>
          </Box>
          <Box >
            <Box position={"relative"} mr="30px">
              <IconButton
                aria-label="message"
                w="22px"
                minW={"22px"}
                icon={<RiNotification4Fill size={"22px"} color="#a0aec0" />}
                cursor={"pointer"}
                onClick={handleOpenMessage}
                variant="unstyled"
              />
              {unReadMsSystemNumn > 0 && (
                <Box
                  position="absolute"
                  top="2px"
                  right="-12px"
                  height="14px"
                  width="14px"
                  bg={"#ff0000"}
                  color="#fff"
                  fontSize={"8px"}
                  textAlign="center"
                  lineHeight={"14px"}
                  borderRadius="50%"
                >
                  {unReadMsSystemNumn}
                </Box>
              )}
            </Box>

            <MessageMenu
              isOpen={messageControl.isOpen}
              onClose={messageControl.onClose}
            />
          </Box>
          <Box>
            {user?.id ? (
              <PersonalMenu
                menuOpen={menuOpen}
                openMenu={openMenu}
                closeMenu={closeMenu}
              />
            ) : (
              <Box>
                <Button
                  className="loginBtn"
                  bg="none"
                  onClick={handLoginOrSignUp}
                  _hover={{ bg: "none" }}
                >
                  登录/注册
                </Button>
                <Modal
                  isOpen={loginDisclosure.isOpen}
                  onClose={loginDisclosure.onClose}
                  size="full"
                >
                  <ModalOverlay />
                  <ModalContent
                    sx={{
                      backgroundImage: `url(${loginbg})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <ModalHeader></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      <Login
                        binding={binding}
                        wxuser={wxuser!}
                        loginBy={loginBy}
                        handleLoginBy={setLoginBy}
                        onClose={loginDisclosure.onClose}
                      />
                    </ModalBody>
                  </ModalContent>
                </Modal>
              </Box>
            )}
          </Box>
        </Flex>
      </div>
    </Box>
  );
};

export default Header;
